import React, { FC } from 'react';

interface BodyCardInterface {
  body: string;
}

const BodyCard: FC<BodyCardInterface> = ({ body }) => {
  return (
    <div className="text-sm leading-6 max-w-[80%] break-words text-neutral-darkest">
      <div>{body}</div>
    </div>
  );
};

export default BodyCard;
